<form class="ui form" #form="ngForm">
    <app-segment-header title="applicant-tracker.applicants.basicInformation"></app-segment-header>
    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.firstName' | translate }}</label>
            <div>{{ applicant?.firstName || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.lastName' | translate }}</label>
            <div>{{ applicant?.lastName || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.email' | translate }}</label>
            <div>{{ applicant?.email || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.phone' | translate }}</label>
            <div>{{ applicant?.phone || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.country' | translate }}</label>
            <div>{{ applicant?.country || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.postalCode' | translate }}</label>
            <div>{{ applicant?.postalCode || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">{{ 'applicant-tracker.applicants.create.jobPosting' | translate }}</label>
            <div>{{ applicant?.jobPosting?.title || 'none' }}</div>
        </div>
    </div>
</form>
